module.exports = __webpack_public_path__ + "img/img08.b0446bf4.png";